import React from 'react'
import { LabelByLang, TableHeadNameByLang } from '../../../common/components/ConvertTextLang';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUpLong,
  faArrowDownLong,
} from "@fortawesome/free-solid-svg-icons";
import {
  SR_NO,
  CLICK_TO_KNOW,
  SHOWING,
  TO,
  OF,
  FILTERED_FROM,
  TOTAL_ENTRIES,
  ENTRIES,
  FILE,
  PREVIOUS,
  NEXT,
} from "../../../common/labels/table_text.json";
import pdfIcon from "../../../images/pdfIcon.png";

// import "../../../styles/main_content.css";
const MenuUserView = ({TableColumnData}) => {
    console.log('TableColumnData',TableColumnData)
  return (
        <div className="table-responsive">
            <table className="table dataTable mb-0" id="datatable">
                <thead>
                <tr>
                    <th className="sorting_desc sr-thead" style={{background: "#2c70c3", padding:" 10px 16px",margin: "0", color: "#fff", border: "1px solid #d5d5d5", fontSize: "14px", fontWeight: "normal"}}>
                    <div className="row">
                        <div className="col"> <LabelByLang obj={SR_NO}/></div>
                    </div>
                    </th>
                    {TableColumnData && 
                    TableColumnData.length > 0 &&
                    TableColumnData.map((columncontent, index) => {
                        return (
                        <th
                            key={index}
                            className="table-header-effect"
                            style={{background: "#2c70c3", padding:" 10px 16px",margin: "0", color: "#fff", border: "1px solid #d5d5d5", fontSize: "14px", fontWeight: "normal"}}
                            // onClick={() => {
                            // setSortLabel(columncontent.fieldName);
                            // setIsSortLabelAsc(!labelSortingStatus[index]);
                            // let lbstatus = [];
                            // setCurrentSortStatus(!labelSortingStatus[index]);
                            // lbstatus[index] = !labelSortingStatus[index];
                            // setLabelSortingStatus((prev) => {
                            //     return [...lbstatus];
                            // });
                            // return;
                            // }}
                        >
                            <div className="row">
                            <div className="col-lg-9 col-md-9">
                            <TableHeadNameByLang obj={columncontent} />
                            </div>
                            <div className="col-lg-3 col-md-3 sort-arrow sort-arrow-block">
                                <span className="minw-18p">
                                <FontAwesomeIcon
                                    size="xs"
                                    icon={faArrowUpLong}
                                    className={`d-pointer`}
                                    // onClick={() => {
                                    // setSortLabel(columncontent.fieldName);
                                    // let lbstatus = [];
                                    // setCurrentSortStatus(!labelSortingStatus[index]);
                                    // lbstatus[index] = !labelSortingStatus[index];
                                    // setLabelSortingStatus((prev) => {
                                    //     return [...lbstatus];
                                    // });
                                    // return;
                                    // }}
                                />
                                <FontAwesomeIcon
                                    size="xs"
                                    icon={faArrowDownLong}
                                    className={`d-pointer`}
                                    // onClick={() => {
                                    // setSortLabel(columncontent.fieldName);
                                    // let lbstatus = [];
                                    // setCurrentSortStatus(!labelSortingStatus[index]);
                                    // lbstatus[index] = !labelSortingStatus[index];
                                    // setLabelSortingStatus((prev) => {
                                    //     return [...lbstatus];
                                    // });
                                    // return;
                                    // }}
                                />
                                </span>
                            </div>
                            </div>
                        </th>
                        );
                    })}
                    <th
                    className="file-thead"
                    style={{background: "#2c70c3", padding:" 10px 16px",margin: "0", color: "#fff", border: "1px solid #d5d5d5", fontSize: "14px", fontWeight: "normal"}}
                    >
                    <span className="m-file"><LabelByLang obj={FILE} /></span>
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="fwidth-65p" style={{border: "1px solid #d5d5d5"}}>{1}</td>
                        {TableColumnData && 
                            TableColumnData.length > 0 &&
                            TableColumnData.map((data)=>{
                                return <td style={{border: "1px solid #d5d5d5"}}>-</td>
                            })
                        }
                        <td className="fwidth-35p text-center" style={{border: "1px solid #d5d5d5"}}>
                        <a
                            href="# "
                        >
                            <img src={pdfIcon} alt="pdficon" width="24px;" />
                        </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
  )
}

export default MenuUserView